<template>
  <div class="map-layer-controls" :class="`pos-${position}`">
    <!-- Calles / Satélite -->
    <button
      class="mlc-btn"
      :class="{ active: isSatellite }"
      @click="$emit('toggle-satellite')"
      :title="isSatellite ? 'Ver calles' : 'Ver satélite'"
    >
      <i :class="isSatellite ? 'pi pi-map' : 'pi pi-globe'" />
    </button>
    <!-- Mapa de Google -->
    <button
      class="mlc-btn google"
      :class="{ active: google }"
      @click="$emit('toggle-google')"
      :title="google ? 'Usar mapa estándar' : 'Usar mapa de Google'"
    >
      <span class="g">G</span>
    </button>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

defineProps({
  isSatellite: Boolean,
  google: Boolean,
  // 'top-right' (por defecto) o 'bottom-left'
  position: { type: String, default: 'top-right' },
})
defineEmits(['toggle-satellite', 'toggle-google'])
</script>

<style scoped>
.map-layer-controls {
  position: absolute;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pos-top-right {
  top: 10px;
  right: 10px;
}

.pos-bottom-left {
  bottom: 18px;
  left: 10px;
}

.mlc-btn {
  width: 34px;
  height: 34px;
  border-radius: 6px;
  background: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #444;
  font-size: 0.9rem;
  font-weight: 700;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.28), 0 1px 2px rgba(0, 0, 0, 0.14);
  -webkit-tap-highlight-color: transparent;
  transition: background 0.12s;
}

.mlc-btn:active {
  background: #eee;
}

.mlc-btn.active {
  background: #e8f0fe;
}

.mlc-btn .g {
  font-size: 1rem;
  line-height: 1;
  color: #4285f4;
}

.mlc-btn.google.active {
  background: #4285f4;
}

.mlc-btn.google.active .g {
  color: #fff;
}
</style>
